// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  orderAdjustmentsItemCard: {
    padding: theme.spacing(2),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: theme.spacing(1),
    boxShadow: '4px 6px 8px 0px #00000017',
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsItemCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  noTransformText: {
    textTransform: 'none',
  },
  orderAdjustmentsItemCardTitleSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  projectNameText: {
    fontWeight: 600,
    fontSize: '18px',
    marginRight: theme.spacing(2),
  },
  orderAdjustmentsItemCardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    marginBottom: theme.spacing(2),
  },
  orderAdjustmentsItemCardContentItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    borderRight: '2px solid #E5E5E5',
    width: '100%',
    paddingLeft: theme.spacing(2),
    '&:last-child': {
      borderRight: 'none',
    },
    '&:first-child': {
      paddingLeft: '0px',
    },
  },
  orderAdjustmentsItemCardContentItemBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelText: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  reasonSection: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  valueText: {
    fontWeight: 400,
    fontSize: '14px',
  },
  viewAllAdjustmentsSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default styles;
